import { render, staticRenderFns } from "./ResultPrimer.vue?vue&type=template&id=fd593a86"
import script from "./ResultPrimer.vue?vue&type=script&lang=js"
export * from "./ResultPrimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports